import cx from 'classnames';
import styles from './HeroModuleBanner.module.scss';

import React from 'react';

import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import { Grid } from 'components/Grid/Grid';
import { TextV2 } from 'components/TextV2/TextV2';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { toEntry, AppType, WithCMS } from 'services/cms/typesUtil';

type HeroModuleBannerProps = AppType.Component<{
  header?: string;
  body?: string;
  link?: WithCMS<AppType.Content>;
}>;

export const HeroModuleBanner: React.FC<HeroModuleBannerProps> = ({ header, body, link }) => {
  const { browser } = useBreakpoints();
  const isDesktopOrLarge = browser.is.desktop;
  if (!isDesktopOrLarge) return null;

  return (
    <Grid item lg={3} className={styles.banner}>
      {link && (
        <ContentLinkV2 entry={toEntry(link)} hideTitle className={styles.bannerLink}>
          <div className={cx({ [styles.bannerContainer]: header || body })}>
            {header && (
              <TextV2 value={header} tagName="p" variant="body-medium" className={styles.bannerHeader} />
            )}
            {body && <TextV2 value={body} tagName="h4" variant="h4" className={styles.bannerBody} />}
          </div>
        </ContentLinkV2>
      )}
    </Grid>
  );
};

HeroModuleBanner.displayName = 'HeroModuleBanner';
